import { Accordion, Card } from 'react-bootstrap'
import { faFolder } from '@fortawesome/pro-solid-svg-icons'
import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { useTranslation } from 'react-i18next'
import { Carousel as CoursesCarousel } from 'components/home/components/courses-carousel/Carousel'
import { EmptyStateBanner } from 'components/ui/empty-states/empty-state-banner'
import { paths } from 'routes/paths'
import { FolderHeader } from '../../atoms/FolderHeader'
import { AccordionCard } from '../../../../../ui/AccordionCard'
import { AccordionToggle } from '../../../../../ui/AccordionToggle'
import { CourseRow } from '../../types'
import styles from './Courses.module.scss'

export interface ITag {
  name: string
  icon: IconDefinition
}

interface CoursesProps {
  name: string
  totalCourses: number
  courses: CourseRow[]
  href: string
  tag?: ITag
}

export function Courses({
  name,
  totalCourses,
  courses,
  href,
  tag,
}: CoursesProps) {
  const { t } = useTranslation()

  return (
    <Accordion defaultActiveKey="0">
      <AccordionCard className={styles.accordionHeader}>
        <AccordionToggle eventKey="0">
          <FolderHeader
            count={totalCourses || 0}
            iconColor={'#2684ff'}
            icon={faFolder}
            title={name}
            href={href}
            tag={tag}
          />
        </AccordionToggle>
        <Accordion.Collapse eventKey="0">
          <Card.Body className={`px-0 ${styles.myCoursesContainer} `}>
            {courses ? (
              <CoursesCarousel data={courses.slice(0, 8)} />
            ) : (
              <EmptyStateBanner
                text={t(
                  'home.lmsIndex.lmsMyCourses.emptyStates.byCategory.category.text'
                )}
                subtext={t(
                  'home.lmsIndex.lmsMyCourses.emptyStates.byCategory.category.subtext'
                )}
                link={{
                  href: paths.library.root,
                  text: t(
                    'home.lmsIndex.lmsMyCourses.emptyStates.byCategory.category.link'
                  ),
                }}
              />
            )}
          </Card.Body>
        </Accordion.Collapse>
      </AccordionCard>
    </Accordion>
  )
}
